import { z } from 'zod';
import { CATEGORY_KINDS, type CategoryKind } from '../types';
import { dayOfMonthSchema, isoDateSchema, labelSchema, positiveCentsSchema, uuidSchema } from './common';

/**
 * Revenus et charges fixes. Le montant est toujours positif : le sens vient de
 * `kind`. `dayOfMonth` sert à la fois à engendrer la transaction réelle et à
 * dessiner la courbe de solde prévisionnel.
 */
export const recurringItemCreateSchema = z.object({
  accountId: uuidSchema,
  categoryId: uuidSchema.nullable().optional(),
  label: labelSchema,
  kind: z.enum(CATEGORY_KINDS),
  amountCents: positiveCentsSchema,
  dayOfMonth: dayOfMonthSchema,
  startOn: isoDateSchema,
  endOn: isoDateSchema.nullable().optional(),
  isActive: z.boolean().optional(),
});

export const recurringItemUpdateSchema = recurringItemCreateSchema.partial();

export type RecurringItemCreateInput = z.infer<typeof recurringItemCreateSchema>;
export type RecurringItemUpdateInput = z.infer<typeof recurringItemUpdateSchema>;

export interface RecurringItemResponse {
  id: string;
  accountId: string;
  categoryId: string | null;
  label: string;
  kind: CategoryKind;
  amountCents: number;
  dayOfMonth: number;
  startOn: string;
  endOn: string | null;
  isActive: boolean;
}
